import { useState, useEffect } from "react";
import { getIndustries } from "../../../service/employerapi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

function Category() {
  const [loading, setLoading] = useState(false);
  const [industries, setIndustry] = useState([]);

  useEffect(() => {
    const fetchIndustry = async () => {
      try {
        setLoading(true);
        const response = await getIndustries();
        console.log("Raw API Response:", response);

        const data =
          Array.isArray(response?.data?.data)
            ? response.data.data
            : Array.isArray(response?.data)
            ? response.data
            : [];

        console.log("Industries set:", data);
        setIndustry(data);
      } catch (err) {
        console.error("Error fetching Industries:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchIndustry();
  }, []);

  return (
    <section className="categories pt-50 pb-50">
      <div className="site-width">
        <div className="titleSection text-center wow animate__fadeInDown">
          <h2>Browse Talent by Industry</h2>
          <p>Connect with trusted professionals from your industry and hire instantly for hourly roles.</p>
        </div>

        {loading ? (
          <div className="text-center w-100 my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <Swiper
            spaceBetween={20}
            slidesPerView={4}
            navigation
            autoplay={{ delay: 3000 }}
            modules={[Navigation, Autoplay]}
          >
            {industries.map((industry) => (
              <SwiperSlide key={industry.id}>
                {/* <a href={`/candidate-list/${industry.id}`}> */}
                <a href={`/employer/candidate-list-industry/${industry.id}`}>
                  <div className="categoryCard wow animate__zoomIn">
                    <div className="categoryHeader">
                      <div className="categoryContent">
                        <h4 style={{ fontSize: "15px" }}>{industry.name}</h4>
                        <p style={{ fontSize: "13px" }}>
                          {industry.jobSeekerCount} Available
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </section>
  );
}

export default Category;
